document.addEventListener('DOMContentLoaded', () => {
    const viewport = document.getElementById('reviews-viewport');
    const dotsEl = document.getElementById('review-dots');
    const pbar = document.getElementById('progress-bar');
    const dataElement = document.getElementById('monfetech-reviews-data');

    if (!viewport || !dataElement) return;

    const jsonUrl = dataElement.textContent.replace(/"/g, '').trim();
    const DELAY = 5000; // Aumentado a 5s para dar más tiempo de lectura
    let current = 0;
    let cards = [];
    let timer;
    let isPaused = false;
    const reviewsSide = document.querySelector('.reviews-side');

    function goTo(n) {
        cards[current].classList.remove('active');
        cards[current].classList.add('exit');
        const prev = current;
        
        // Sincronizado con los 0.6s (600ms) de la nueva animación CSS
        setTimeout(() => {
            if (cards[prev]) cards[prev].classList.remove('exit');
        }, 600);
        
        current = (n + cards.length) % cards.length;
        cards[current].classList.add('active');
        document.querySelectorAll('.rdot').forEach((d, i) => d.classList.toggle('active', i === current));
        startBar();
    }

    function startBar() {
        clearTimeout(timer);
        pbar.style.transition = 'none';
        pbar.style.width = '0%';
        
        if (isPaused) return; // Si el mouse está encima, no arranca la barra
        
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                pbar.style.transition = `width ${DELAY}ms linear`;
                pbar.style.width = '100%';
            });
        });
        timer = setTimeout(() => goTo(current + 1), DELAY);
    }

    // Lógica para pausar cuando el usuario está leyendo (Hover)
    if (reviewsSide) {
        reviewsSide.addEventListener('mouseenter', () => {
            isPaused = true;
            clearTimeout(timer);
            // Congelar la barra de progreso exactamente en donde está
            const computedWidth = window.getComputedStyle(pbar).width;
            pbar.style.transition = 'none';
            pbar.style.width = computedWidth;
        });
        
        reviewsSide.addEventListener('mouseleave', () => {
            isPaused = false;
            startBar(); // Reinicia el tiempo cuando saca el mouse
        });
    }

    function buildDots(total) {
        dotsEl.innerHTML = '';
        for (let i = 0; i < total; i++) {
            const d = document.createElement('button');
            d.className = 'rdot' + (i === 0 ? ' active' : '');
            d.setAttribute('aria-label', 'Reseña ' + (i + 1));
            d.onclick = () => goTo(i);
            dotsEl.appendChild(d);
        }
    }

    fetch(jsonUrl)
        .then(response => {
            if (!response.ok) throw new Error("No se pudo cargar el archivo JSON");
            return response.json();
        })
        .then(data => {
            viewport.innerHTML = '';

            if (!data.reviews || data.reviews.length === 0) {
                viewport.innerHTML = '<p style="color:white; text-align:center;">No hay reseñas disponibles.</p>';
                return;
            }

            data.reviews.forEach((review, i) => {
                const name = review.author_name || "Anónimo";
                const initial = name.charAt(0).toUpperCase();

                const photo = (review.profile_photo_url && review.profile_photo_url.startsWith('http'))
                               ? `<img src="${review.profile_photo_url}" alt="${name}">`
                               : `<div class="avatar-initial">${initial}</div>`;

                const card = document.createElement('div');
                card.className = 'monfetech-card' + (i === 0 ? ' active' : '');
                card.dataset.index = i;
                card.innerHTML = `
                    <div class="card-top">
                        <div class="avatar">${photo}</div>
                        <div class="card-meta">
                            <div class="reviewer-name">${name}</div>
                            <div class="stars">${'★'.repeat(review.rating || 5)}</div>
                        </div>
                    </div>
                    <p class="comment">"${review.text || ''}"</p>
                    <div class="review-verified">
                        <svg viewBox="0 0 24 24" fill="none" stroke="#81c784" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" width="13" height="13">
                            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                            <polyline points="22 4 12 14.01 9 11.01"/>
                        </svg>
                        Compra verificada en Google
                    </div>
                `;
                viewport.appendChild(card);
            });

            cards = Array.from(viewport.querySelectorAll('.monfetech-card'));
            buildDots(cards.length);
            startBar();
        })
        .catch(err => {
            console.error("Error al cargar reseñas:", err);
            viewport.innerHTML = `<p style="color:red; text-align:center;">Error al cargar las reseñas.</p>`;
        });
});